import { dp } from "api/endpoints";
import { importView } from "../utils/misc";

const AccountList = importView("account/List");
const AccountForm = importView("account/Form");
const ProdList = importView("product");
const TxnForm = importView("txn");
const Acnt2Acnt = importView("txn/fin/Acnt2Acnt");
const DpToBank = importView("txn/fin/DpToBank");
const Acnt2Ln = importView("txn/fin/Acnt2Ln");

const dpRoutes = {
  path: "/",
  children: [
    {
      path: dp.accounts,
      element: <AccountList />,
    },
    {
      path: `${dp.account}/:AcntNo`,
      element: <AccountForm />,
    },
    {
      path: dp.products,
      element: <ProdList />,
    },
    {
      path: dp.finTxn,
      element: <TxnForm />,
    },
    {
      path: dp.acnt2acnt,
      element: <Acnt2Acnt />,
    },
    {
      path: dp.acnt2ln,
      element: <Acnt2Ln />,
    },
    {
      path: dp.dpToBank,
      element: <DpToBank />,
    },
  ],
};

export default dpRoutes;
